import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/Global.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

if (document.readyState === 'complete') {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  window.addEventListener('load', () => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  });
}
